export default __webpack_public_path__ + "static/media/chemist.eb07ed87.png";